export default "__VITE_ASSET__Dv5yVChn__"